import { ContractLog } from "../../classes";

const ContractLogModule = {
  namespaced: true,
  state: {
    contractLog: [],
  },
  actions: {
    getContractLog: async ({ commit }, payload) => {
      try {
        const data = await ContractLog.getContractLog({ id: payload.contractId });
        commit("setContractLog", data );
        return data;
      } catch (err) {
        throw err;
      }
    },
    getContractLogByContracts: async ({ commit }, payload) => {
      try {
        const data = await ContractLog.getContractLogByContracts(payload);
        return data;
      } catch (err) {
        throw err;
      }
    },
  },
  getters: {
    getContractLog: state => { return state.contractLog }
  },
  mutations: {
    setContractLog: (state, payload) => {
      state.contractLog = payload;
    },
  }
};
export default ContractLogModule;
